import { GETO_MOBILE_ACCESS_CODE, GETO_PC_ACCESS_CODE } from "@/consts";
import { getAccessCode } from "@/lib/utils";

export const getIsGetoAccessCode = () => {
  const accessCode = getAccessCode();
  return accessCode === GETO_PC_ACCESS_CODE || accessCode === GETO_MOBILE_ACCESS_CODE;
};
